import { api } from "../App";
import { SET_DIRECTORY_OBJECTS_UMB, SET_DIRECTORY_OBJECTS_UMB_LOAD, SET_TFO_BASE_OBJ_LIST, SET_TFO_TYPES_LIST, SET_EQUIPMENTS_LIST, SET_EQUIPMENTS_BY_ROOM_LIST, SET_DIRECTORY_MODAL_LIST } from "./types";
import { createNotification } from "../components/Notifications/Notifications";

export const getDirectoryObjectsUMBList = (data) => async (dispatch, getState) => {
  try {
    const urlParams = new URLSearchParams(data).toString();
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB_LOAD, payload: true });
    const { data: result } = await api.get(`/tfo/object_umb?${urlParams}`);
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB, payload: result });
  } catch (error) {
    console.error('Error in directoryObjectsUMB action:', error);
  } finally {
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB_LOAD, payload: false });
  }
};
export const getDirectoryForModalList = (data) => async (dispatch, getState) => {
  try {
    const urlParams = new URLSearchParams(data).toString();
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB_LOAD, payload: true });
    const { data: result } = await api.get(`/tfo`);
    dispatch({ type: SET_DIRECTORY_MODAL_LIST, payload: result });
  } catch (error) {
    console.error('Error in directoryObjectsUMB action:', error);
  } finally {
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB_LOAD, payload: false });
  }
};
export const getModalElement = (data) => async (dispatch, getState) => {
  try {
    const urlParams = new URLSearchParams(data).toString();
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB_LOAD, payload: true });
    const { data: result } = await api.get(`/tfo/${data.tfoid}`);
    dispatch({ type: SET_DIRECTORY_MODAL_LIST, payload: result });
  } catch (error) {
    console.error('Error in directoryObjectsUMB action:', error);
  } finally {
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB_LOAD, payload: false });
  }
};

export const editObjectUMB = (data) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB_LOAD, payload: true });
    await api.put(`/tfo/${data.tfoid}`, data);
    createNotification('success', 'Успешно');
    dispatch(getDirectoryObjectsUMBList())
    dispatch(getDirectoryForModalList())
  } catch (error) {
    console.error('Error in directoryObjectsUMB action:', error);
  } finally {
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB_LOAD, payload: false });
  }
};

export const addObjectUMB = (data) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB_LOAD, payload: true });
    await api.post(`/tfo`, data);
    createNotification('success', 'Успешно');
    dispatch(getDirectoryObjectsUMBList())
    dispatch(getDirectoryForModalList())
  } catch (error) {
    console.error('Error in directoryObjectsUMB action:', error);
  } finally {
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB_LOAD, payload: false });
  }
};

export const deleteObjectUMB = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB_LOAD, payload: true });
    await api.delete(`/tfo/${id}`);
    createNotification('success', 'Успешно');
    dispatch(getDirectoryObjectsUMBList());
  } catch (error) {
    console.error('Error in directoryObjectsUMB action:', error);
  } finally {
    dispatch({ type: SET_DIRECTORY_OBJECTS_UMB_LOAD, payload: false });
  }
};



export const getTFOBaseObjList = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/tfo_bases`);
    dispatch({ type: SET_TFO_BASE_OBJ_LIST, payload: data });
  } catch (error) {
    console.error('Error in directoryObjectsUMB action:', error);
  }
};

// export const getEquipmentsList = (id) => async (dispatch, getState) => {
//   await dispatch(checkAndUpdateToken());
//   if (getState().auth.token) {
//     const response = await fetch(`${API_BASE_URL}/equipments/${id}`, {
//       method: "GET",
//       ...buildDefaultHeaders(getState),
//     });
//     if (response.ok) {
//       const data = await response.json();
//       dispatch({ type: SET_EQUIPMENTS_LIST, payload: data});
//     }
//   }
// };

// export const getEquipmentsByRoom = (id) => async (dispatch, getState) => {
//   await dispatch(checkAndUpdateToken());
//   if (getState().auth.token) {
//     const response = await fetch(`${API_BASE_URL}/equipments/room/${id}`, {
//       method: "GET",
//       ...buildDefaultHeaders(getState),
//     });
//     if (response.ok) {
//       const data = await response.json();
//       dispatch({ type: SET_EQUIPMENTS_BY_ROOM_LIST, payload: data});
//     }
//   }
// };

// export const setEquipmentsForRoom = (data = [], id) => async (dispatch, getState) => {
//   try {
//     await dispatch(checkAndUpdateToken());
//     if (getState().auth.token) {
//       // dispatch({ type: SET_ROOMS_LOAD, payload: true });
//       const response = await fetch(`${API_BASE_URL}/rooms_equipments`, {
//         method: "POST",
//         ...buildDefaultHeaders(getState),
//         body: JSON.stringify(data)
//       });
//       if (response.ok) {
//         createNotification('success', 'Успешно');
//         dispatch(getEquipmentsByRoom(id));
//       } else {
//         createNotification('error', 'Ошибка')
//       }
//     }
//   } catch (ERR) {
//   } finally {
//     // dispatch({ type: SET_ROOMS_LOAD, payload: false });
//   }
// };

// export const deleteEquipment = (id, idAquip) => async (dispatch, getState) => {
//   await dispatch(checkAndUpdateToken());
//   if (getState().auth.token) {
//     const response = await fetch(`${API_BASE_URL}/rooms_equipment/${id}/${idAquip}`, {
//       method: "DELETE",
//       ...buildDefaultHeaders(getState),
//     });
//     if (response.ok) {
//       createNotification('success', 'Успешно');
//         dispatch(getEquipmentsByRoom(id));
//         dispatch(getEquipmentsList(id));
//     }
//   }
// };